<template>
	<div class="dropleft grid-settings" ref="gridSettings">
		<button class="btn menu-btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ref="gridSettingsButton">
			<icon name="cog" style="font-size: 15px" />
		</button>
		<ul class="dropdown-menu multi-level py-0" style="max-height: 100%" role="menu" aria-labelledby="dropdownMenu" ref="dropdown">
			<li class="p-0 " ref="li_buttons" v-for="button in buttons" :key="button.id">
				<!--        <nk-button  v-for="button in buttons" :key="button.id" :class="button.class" @click="()=>{ button.handler();$refs.li_buttons.click()}" @submit="button.handler" :options="button.options" class="m-1" />-->
				<a :class="button.class" @click="() => { button.handler() }" class="dropdown-item py-2 pr-2 pl-5">
					<icon :name="button.options.icon" />
					<span class="mr-3">{{ button.options.title }}</span>
				</a>
			</li>

			<!-- Columns Visibility -->
			<li class="dropdown-submenu">
				<a class="dropdown-item py-2 pr-2 pl-5">
					<icon name="th-list" />
					<span class="mr-3">{{ $t("table.settings.columns-choose") }}</span>
				</a>
				<ul class="dropdown-menu mr-0 py-0">
					<li class="dropdown-item p-0" v-for="column in filteredColumns" :key="column.id">
						<ColumnsVisibility @change-visibility="changeVisibility" :column="column" />
					</li>
				</ul>
			</li>

			<!-- Grid Exporter -->
			<li class="dropdown-submenu" v-if="permissions.exportPermission">
				<a class="dropdown-item py-2 pr-2 pl-5">
					<icon name="file-export" />
					<span class="mr-3">{{ $t("table.export.export") }}</span>
				</a>
				<ul class="dropdown-menu py-0 mr-0">
					<GridExporter :filteredData="filteredData" :filteredColumns="filteredColumns" :stateUID="stateUID" />
				</ul>
			</li>

			<!-- Template Save -->
			<li v-if="stateUID != null && stateUID !== ''" class="dropdown-item py-2 pr-2 pl-5" @click="templatesButtonClicked">
				<span>
					<icon name="save" />
					<span class="mr-3"> {{ $t("table.settings.save-template") }}</span>
				</span>
			</li>

			<li class="dropdown-divider my-0"></li>

			<!-- Filter Row Checked -->
			<li class="dropdown-item p-0 filter-row-visibility-li">
				<label class="form-check-label p-2" style="font-size: 12px; font-weight: 400">
					<input type="checkbox" class="form-check-input" :checked="filterRowChecked" :value="filterRowChecked" @change="filterRowVisibility" />
					<span class="mr-4 pr-1">
						{{ $t("table.settings.show-filter") }}
					</span>
				</label>
			</li>

			<!-- Aggregate Row Checked -->
			<li class="dropdown-item p-0 aggregate-row-visibility-li" v-if="permissions.aggregatesPermission && filteredColumns.some(x => x.aggregates?.length)">
				<label class="form-check-label p-2" style="font-size: 12px; font-weight: 400">
					<input type="checkbox" class="form-check-input" :checked="aggregateRowChecked" :value="aggregateRowChecked" @change="aggregateRowVisibility" />
					<span class="mr-4 pr-1">
						{{ $t("table.settings.show-aggregate") }}
					</span>
				</label>
			</li>
		</ul>

	</div>
</template>
<script>
	import ColumnsVisibility from './columns-visibility'
	import GridExporter from './grid-exporter.vue'
	import $ from 'jquery'
	import Icon from '../general/icon.vue'

	export default {
		name: 'GridSettings',

		// Props
		props: {
			filteredColumns: {
				type: Array,
				default() {
					return []
				},
			},

			filteredData: {
				type: Array,
				default() {
					return []
				},
			},

			stateUID: {
				type: String,
				default: '',
			},

			filterRowChecked: {
				type: Boolean,
				default: true,
			},

			aggregateRowChecked: {
				type: Boolean,
				default: true,
			},
			buttons: {
				type: Array,
				default: [],
			},
			permissions: {
				type: Object
			}
		},

		emits: ['change-visibility', 'templates-button-clicked', 'filter-row-visibility', 'aggregate-row-visibility'],

		// Mounted
		mounted() {
			$(document).on('click', '.filter-row-visibility-li', (e) => {
				e.stopPropagation()
			})

			$(this.$refs.gridSettings).on('show.bs.dropdown', (e) => {
				$(this.$refs.dropdown).prependTo($(e.target).closest('.grid-mainbar'))
			})
		},

		beforeUnmount() {
			$(document).off('click', '.filter-row-visibility-li')
			$(this.$refs.gridSettings).off('show.bs.dropdown')
		},

		// Components
		components: {
			ColumnsVisibility,
			GridExporter,
			Icon,
		},

		// Methods
		methods: {
			changeVisibility(column) {
				this.$emit('change-visibility', column)
			},

			templatesButtonClicked() {
				this.$emit('templates-button-clicked')
			},

			filterRowVisibility() {
				this.$emit('filter-row-visibility')
			},

			aggregateRowVisibility() {
				this.$emit('aggregate-row-visibility', !this.aggregateRowChecked)
			},

		},
	}
</script>
